<template>
    <div>
        <v-container fluid grid-list-xl class="assessment-start-container general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar-medical-device
                        :shortcut-nav="this.shortcutNav"
                        @setIsKeyboardNav="setIsKeyboardNav"
                        :title="text('api.pro.startAssessmentPage.title')"></header-bar-medical-device>
                </v-flex>
            </v-layout>

            <div class="scrolling-content" ref="assessmentPriorityScrollingContentRef">

                <v-container fluid v-if="mustShowPatientPanel">
                    <v-layout row wrap class="" >

                        <v-flex xs12 sm3 md3 lg3 class="no-padding-top no-padding-left" >
                            <patient-profile ref="patientProfileRef"
                                             :class="{'panel-highlighted': (shortcutNav.isPanelHighlight && shortcutNav.crtPanel === 'PATIENT_INFO')}"
                                             @click.native="onPanelClick('PATIENT_INFO')"
                                             :shortcutNav="this.shortcutNav">
                            </patient-profile>
                        </v-flex>

                        <v-flex xs12 sm7 md7 lg7 class="selected-symptoms no-padding-top" >
                            <div  class="assessment-start-priority-list-questions">
                                <questions-priority-list ref="questionsPriorityListRef"
                                                         :shortcutNav="this.shortcutNav"
                                                         @emitQuestionClick="onQuestionClick"
                                                         @emitChangeAnswer="onChangeAnswer">
                                </questions-priority-list>
                            </div>
                        </v-flex>

                        <v-flex xs12 sm2 md2 lg2 class="sticky-column no-padding-top">
                            <v-card class="symptom-description component-bg-color" v-if="symptomName" :height="null">
                                <v-card-title class="no-padding-left no-padding-right" v-if="symptomName">
                                    <h4 v-if="relatedSymptomName">
                                        {{relatedSymptomName}}: {{symptomName}}
                                    </h4>
                                    <h4 v-else>
                                        {{symptomName}}
                                    </h4>
                                    <div v-html="symptomText"></div>
                                </v-card-title>
                                <v-card-title v-if="!symptomName">
                                    No symptom selected
                                </v-card-title>
                                <v-card-text class="px-0 border-top">
                                    <div v-html="symptomDescription" class="symptom-description-html"></div>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container  fluid v-else>
                    <v-layout row wrap>
                        <v-flex xs12 class="selected-symptoms hide-patient-panel" >
                            <v-container fluid class="padding-right-xs padding-top-xs priority-questions-auto-login">
                                <v-layout row wrap>
                                    <v-flex  xs12 sm9 class="priority-questions">
                                        <questions-priority-list ref="questionsPriorityListRef"
                                                                 :shortcutNav="this.shortcutNav"
                                                                 @emitQuestionClick="onQuestionClick"
                                                                 @emitChangeAnswer="onChangeAnswer">
                                        </questions-priority-list>
                                    </v-flex>
                                    <v-flex xs12 sm3 class="symptom-description-hide-patient-panel sticky-column">
                                        <v-card class="symptom-description component-bg-color" v-if="symptomName" :height="null">
                                            <v-card-title v-if="symptomName">
                                                <h4 v-if="relatedSymptomName">
                                                    {{relatedSymptomName}}: {{symptomName}}
                                                </h4>
                                                <h4 v-else>
                                                <span v-if="symptomType=== 'START'">
                                                    {{text('db.product.PROD_TITLE_START')}}:
                                                </span>
                                                    <span v-if="symptomType=== 'GENERAL'">
                                                    {{text('db.product.PROD_TITLE_GEN')}}:
                                                </span>
                                                    <span>{{symptomName}}</span>
                                                </h4>


                                                <div v-html="symptomText"></div>
                                            </v-card-title>
                                            <v-card-title v-if="!symptomName">
                                                No symptom selected
                                            </v-card-title>
                                            <v-card-text class="px-0">
                                                <div v-html="symptomDescription" class="symptom-description-html"></div>
                                            </v-card-text>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-container>

                        </v-flex>
                    </v-layout>
                </v-container>


            </div>
        </v-container>


        <v-footer app class="elevation-bg-color border-top-invisible">
            <v-layout row wrap class="padding-left-xxl padding-right-xxl">
                <v-flex xs12 text-xs-center>
                    <v-btn @click="gotoScoringPage()"
                           id="btnFinishAssessment"
                           class="footer-btn goToScoring"
                           :class="{'is-semi-target': isSemiTarget}"
                           flat
                    >
                        {{text('api.button.finish')}}
                        <finish-icon />
                    </v-btn>

                    <div class="footer-right-btns">
                        <v-btn color="primary"
                               @click="goToNextPage"
                               :disabled="!isFooterNextBtnEnabled && !isSemiTarget"
                               id="btnGoToNextAssessmentPage"
                               class="footer-btn footer-btn-next color-on-primary-text"
                               :class="{'is-semi-target': isSemiTarget}"
                        >
                            {{ text('api.button.next') }}
                            <arrow-next-icon :svg-fill-class="'svg-on-primary-color'"/>
                        </v-btn>
                    </div>

                </v-flex>
            </v-layout>
        </v-footer>
        <div class="cookies-display">
            <detect-browser-cookie></detect-browser-cookie>
            <accept-cookie></accept-cookie>
        </div>
        <general-questions-popup></general-questions-popup>

        <div v-if="getMustShowVitalParamsForm" class="vital-params-form-overlay overlay overlay--active"></div>
    </div>
</template>

<!-- ################################################################## -->

<script>
import HeaderBar from "../shared/HeaderBar";
import TopBar from '../../../common/components/shared/TopBar';
import PatientProfile from "./PatientProfile";
import StartQuestions from "./StartQuestions";
import GeneralQuestions from "./GeneralQuestions";
import {mapActions, mapGetters} from 'vuex';
import AssessmentAlerts from "../../../common/components/shared/AssessmentAlerts";
import AcceptCookie from '../cookies/AcceptCookie';
import QuestionsPriorityList from "./QuestionsPriorityList";
import HeaderBarMedicalDevice from "../shared/HeaderBarMedicalDevice";
import DetectBrowserCookie from '../../../common/components/cookies/DetectBrowserCookie';
import GeneralQuestionsPopup from '../../../common/components/shared/GenQAreNotAllAnswPopup';
import FinishIcon from "../../../common/components/svg/shared/finishIcon";
import ArrowNextIcon from "../../../common/components/svg/shared/arrowNextIcon";
import {forEach} from "axios/lib/utils";


const ASP_PANEL = {
        PATIENT_INFO: "PATIENT_INFO",
        QUESTIONS_PANEL: "QUESTIONS_PANEL"
    };

    const PATIENT_INFO_FIELD = {
        FIELD_PID: "FIELD_PID",
        FIELD_COMMENT: "FIELD_COMMENT"
    };

    export default {
        name: 'AssessmentStartListPage',
        components: {
            ArrowNextIcon,
            FinishIcon,
            GeneralQuestions,
            StartQuestions,
            PatientProfile,
            HeaderBar,
            TopBar,
            AssessmentAlerts,
           // PatientInfo,
            AcceptCookie,
            QuestionsPriorityList,
            HeaderBarMedicalDevice,
            DetectBrowserCookie,
            GeneralQuestionsPopup
        },

        beforeCreate() {
            if (typeof this.$route.query.referral === "undefined" || (this.$route.query.referral !== "testsTreeNode" && this.$route.query.referral !== "autoLogin")) {
                this.$store.commit('AssessmentStartStore/resetStore');
                this.$store.commit('AssessmentAlertsStore/resetStore');
                this.$store.commit('ScoringStore/setIsAssessmentSealed', false);
            }
        },

        created () {
            // If the url has param ?referral=testsTreeNode, that means that we are coming from tests tree,
            // so data for this page should be already loaded and must be kept and used.
            // Otherwise, (re)load data now.
            if (typeof this.$route.query.referral !== "undefined" && this.$route.query.referral === "testsTreeNode") {
                this.$router.replace({'referral': null});
            }
            else if (typeof this.$route.query.referral !== "undefined" && this.$route.query.referral === "testsProductList") {
                this.$store.dispatch("AssessmentStartStore/loadAssessmentTestData");
                this.$router.replace({'referral': null});
            }
            else if ( typeof this.$route.query.referral !== "undefined" && this.$route.query.referral === "autoLogin"){
                // remove the query parameter
                this.$router.replace({'referral': null});

                // load the assessment start data.
                this.$store.dispatch("AssessmentStartStore/loadAssessmentStartData")
                    .then((response) =>{

                        // this will get the pid if it was provided
                        this.$store.commit("AssessmentStartStore/setPatientProfileData", this.$store.getters['SubmittedValuesStore/getPatientProfileData']);

                        // now that all the values are set we can clean the submittedValuesStore.
                        this.$store.commit('SubmittedValuesStore/resetStore');

                    })
                    .catch((error) => {
                        console.log(error);
                        // 251 = UNKNOWN_PRODUCT_CODE, 204 = ASSESSMENT_TOKEN_INVALID
                        if (error.serverResponse != null && error.serverResponse.data != null) {
                            if(error.serverResponse.data.returnCode === 251){
                                console.log("invalid production code");
                                this.$store.commit('SubmittedValuesStore/setErrorMessages', 'Unauthorised Access To Product');
                                this.$store.dispatch("UserStore/submitLogout").then((response) => {
                                    console.log("has been logged out");
                                    this.$store.commit('SubmittedValuesStore/setErrorKey', 'userNotRegistratedForProduct');
                                    this.$router.push({path: '/auto-login'});
                                });
                            }else if(error.serverResponse.data.returnCode === 204 ){
                                console.log("The assessmenttoken already exists");
                                this.$store.commit('SubmittedValuesStore/setErrorMessages','AssessmentToken already exixists');
                                this.$store.dispatch("UserStore/submitLogout").then((response) => {
                                    this.$store.commit('SubmittedValuesStore/setErrorKey', 'assessmentTokenExists');
                                    console.log("has been logged out");
                                    this.$router.push({ path: '/auto-login'});
                                });
                            }
                            else if (error.serverResponse.data.returnCode === 275) {
                                console.log("The assessmenttoken format invalid");
                                this.$store.commit('SubmittedValuesStore/setErrorMessages','AssessmentToken format invalid');
                                this.$store.dispatch("UserStore/submitLogout").then((response) => {
                                    console.log("has been logged out");
                                    this.$store.commit('SubmittedValuesStore/setErrorKey', 'assessmentTokenFormatInvalid');
                                    this.$router.push({ path: '/auto-login'});
                                });
                            }
                            else if (error.serverResponse.data.returnCode === 116) {
                                console.log("Unauthorised Access To Product");
                                this.$store.commit('SubmittedValuesStore/setErrorMessages', 'Unauthorised Access To Product');
                                this.$store.dispatch("UserStore/submitLogout").then((response) => {
                                    console.log("has been logged out");
                                    this.$store.commit('SubmittedValuesStore/setErrorKey', 'unauthorisedAccessToProduct');
                                    this.$router.push({path: '/auto-login'});
                                });
                            }
                        }

                        // 263 == INVALID PARAMETER NAME OR VALUE
                        else if (error.data.returnCode === 263 && error.data.paramMedValidation != null) {

                            if (error.data.paramMedValidation.generalValidationError != null) {
                                const generalValidationError = error.data.paramMedValidation.generalValidationError;
                                if (generalValidationError.validationError != null && generalValidationError.validationErrorParam != null) {
                                    this.$store.commit('SubmittedValuesStore/setErrorMessages', generalValidationError.validationError);
                                    this.$store.commit('SubmittedValuesStore/setErrorMessages', generalValidationError.validationErrorParam);
                                    this.$store.dispatch("UserStore/submitLogout").then((response) => {
                                        console.log("has been logged out");
                                        this.$store.commit('SubmittedValuesStore/setErrorKey', 'generalValidationError');
                                        this.$router.push({ path: '/auto-login'});
                                    });
                                }
                            }

                            if (error.data.paramMedValidation.invalidModuleForParamMed != null) {
                                const invalidModuleForParamMed = error.data.paramMedValidation.invalidModuleForParamMed;
                                if (invalidModuleForParamMed === true) {
                                    const invalidModuleForParamMedErrorMessage = this.text('api.autologin.invalid.module');
                                    this.$store.commit('SubmittedValuesStore/setErrorMessages', invalidModuleForParamMedErrorMessage);
                                    this.$store.dispatch("UserStore/submitLogout").then((response) => {
                                        this.$store.commit('SubmittedValuesStore/setErrorKey', 'invalidModuleForParamMed');
                                        this.$router.push({ path: '/auto-login'});
                                    });
                                }
                            }

                            if (error.data.paramMedValidation.invalidMappingToQuestionAnswerMap != null) {
                                const invalidParametersMap = error.data.paramMedValidation.invalidMappingToQuestionAnswerMap;
                                const invalidParametersArray = Object.keys(invalidParametersMap);
                                if (invalidParametersArray.length > 0) {
                                    let errorMessage = this.text('api.autologin.invalid.parameters');
                                    this.$store.commit('SubmittedValuesStore/setErrorMessages', errorMessage);
                                    forEach(invalidParametersArray, (parameter, index) => {
                                        const parameterMessage = (index + 1) + '. ' + parameter + ' : ' + invalidParametersMap[parameter];
                                        this.$store.commit('SubmittedValuesStore/setErrorMessages', parameterMessage);
                                    });

                                    this.$store.dispatch("UserStore/submitLogout").then((response) => {
                                        this.$store.commit('SubmittedValuesStore/setErrorKey', 'invalidValueForParameters');
                                        this.$router.push({ path: '/auto-login'});
                                    });
                                }
                            }

                            if (error.data.paramMedValidation.invalidParamMedNameList != null && error.data.paramMedValidation.invalidParamMedNameList.length > 0) {
                                const invalidParamMedNameList = error.data.paramMedValidation.invalidParamMedNameList;
                                let errorMessage = this.text('api.autologin.invalid.parameter.name');

                                this.$store.commit('SubmittedValuesStore/setErrorMessages', errorMessage);
                                forEach(invalidParamMedNameList, (parameter, index) => {
                                    const parameterMessage = (index + 1) + '. ' + parameter;
                                    this.$store.commit('SubmittedValuesStore/setErrorMessages', parameterMessage);
                                });

                                this.$store.dispatch("UserStore/submitLogout").then((response) => {
                                    this.$store.commit('SubmittedValuesStore/setErrorKey', 'invalidParamMedNameList');
                                    this.$router.push({ path: '/auto-login' });
                                });
                            }
                        }

                    });
            }
            else {
                this.$store.dispatch("AssessmentStartStore/loadAssessmentStartData");
            }

            window.addEventListener('keydown', this.handleKeyDowns);
            window.addEventListener('keyup', this.handleKeyUps);
            window.addEventListener('click', this.handleClicks);
        },

        destroyed() {

            window.removeEventListener('keydown', this.handleKeyDowns);
            window.removeEventListener('keyup', this.handleKeyUps);
            window.removeEventListener('click', this.handleClicks);
        },

        beforeMount() {
            let mustShowPatientPanel = sessionStorage.getItem('must-show-patient-panel');
            if (mustShowPatientPanel !== null) {
                this.mustShowPatientPanel = (mustShowPatientPanel == 'false') ? false : true;
            }
        },

        data() {
            return {
                mustShowPatientPanel: true,
                tempPatientComment: "",

                // When TRUE => Show the Comment Popup for page Assessment Start Priority
                // opened without PATIENT_INFO panel (mustShowPatientPanel == false)
                showComment: false,

                shortcutNav: {

                    isKeyboardNav: false,
                    isPanelHighlight: false,

                    crtPanel: ASP_PANEL.QUESTIONS_PANEL,
                    crtQuestion: null,
                    crtAnswer: null,

                    // Patient Info panel
                    crtPatientField: PATIENT_INFO_FIELD.FIELD_PID,

                    isFieldInEdit: false, // Replaced by navIsFieldInEdit()
                },

                isKeyDown: {}
            };
        },

        computed: {
            ...mapGetters({
                languageList: 'TranslationStore/getLanguageList',
                isAdmin: 'UserStore/getIsAdmin',
                isFooterNextBtnEnabled: 'AssessmentStartStore/getIsFooterNextBtnEnabled',
                selectedProductCode: 'ProductListStore/getSelectedProductCode',
                patientProfileStatus: 'AssessmentStartStore/getPatientProfileStatus',
                patientProfileData: 'AssessmentStartStore/getPatientProfileData',
                symptomName: 'SymptomsQuestionsStore/getSymptomName',
                symptomDescription: 'SymptomsQuestionsStore/getSymptomDescription',
                symptomText: 'SymptomsQuestionsStore/getSymptomText',
                relatedSymptomName: 'SymptomsQuestionsStore/getRelatedSymptomName',
                symptomType: 'SymptomsQuestionsStore/getSymptomType',
                sexQuestion: 'SubmittedValuesStore/getSex',

                getQuestionPriorityList: 'AssessmentStartStore/getQuestionPriorityList',
                mustShowScoringPopup: 'AssessmentAlertsStore/getMustShowScoringPopup',
                mustShowUrgentPopup: 'AssessmentAlertsStore/getMustShowUrgentPopup',
                getSemiTarget: 'AssessmentAlertsStore/getSemiTarget',
                medicalStatuses: 'AssessmentAlertsStore/getMedicalStatuses',
                medicalStatus: 'AssessmentAlertsStore/getMedicalStatus',
                mustShowVitalParametersForm: 'VitalParametersStore/getMustShowVitalParamsForm',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                mustGeneralQuestionAreNotAllAnsweredPopup: 'AssessmentStartStore/getGeneralQuestionAreNotAllAnsweredPopup',
                mustShowInfoPopup: 'MedicalDeviceInfoStore/getMustShowMedicalDeviceInfoPopup',
                getMustShowVitalParamsForm: 'VitalParametersStore/getMustShowVitalParamsForm',
            }),

            mustShowCodes: {
                get () {
                    return this.$store.getters['UserStore/getDebugMustShowCodes'];
                },
                set (newVal) {
                    this.$store.commit('UserStore/setDebugMustShowCodes', newVal);
                },
            },

            questionListPriority() {
                return this.getQuestionPriorityList.questions;
            },

            isSemiTarget () {
                // I created a computed method to be useful if we will need to add a more complex condition
                // in order to visually mark the semiTarget attribute in the page (ex. buttons colors).
                return ((this.getSemiTarget === true) ? true : false);
            }

        },

        methods: {

            ...mapActions({
                showScoringPopup: 'AssessmentAlertsStore/showScoringPopup'
            }),

            setTemporaryPatientCommentValue() {
                this.tempPatientComment = this.patientProfileData.comment;
            },

            isPatientCommentChanged() {
                return this.tempPatientComment !== this.patientProfileData.comment;
            },

            savePatientComment: function() {
                if (this.isPatientCommentChanged()) {
                    this.$store.dispatch("AssessmentStartStore/submitPatientProfileComment", {
                        fieldName: "COMMENT",
                        fieldValue: this.patientProfileData.comment
                    });
                }
                this.showComment = false;
            },

            goToPreviousPage() {
                this.$router.push('/home');
            },

            goToNextPage() {

                if (this.isFooterNextBtnEnabled || this.isSemiTarget) {

                    if (this.getQuestionPriorityList.warningNotAnsweredMandatoryQuestion === true) {
                        this.$store.commit('AssessmentStartStore/setGeneralQuestionAreNotAllAnsweredPopup', true);
                    }
                    else {
                        // Go to Choose Main Symptom page.
                        if(this.patientProfileStatus !== false) {
                            setTimeout( () => this.$router.push('/main-symptom'), 100);
                        }
                    }

                }
            },
            clearStoreAndLogout() {
                this.$store.commit("SubmittedValuesStore/resetStore");
                this.$store.dispatch("UserStore/submitLogout").then((response) => {
                    this.$router.push('/');
                });
            },
            setLanguage() {
                const currentLang = this.selectedLang;
                if(currentLang !== this.assessmentLanguage) {
                    if(this.languageList.includes(this.assessmentLanguage)){
                        this.selectedLang = this.assessmentLanguage;
                        this.$store.commit("TranslationStore/setSelectedLanguage", this.assessmentLanguage);
                    }
                }
            },
            gotoScoringPage(){
                let promiseEvaluateAssessment = this.$store.dispatch('EvaluationStore/evaluateAssessment', {
                    shortcutUsed: true
                });
                promiseEvaluateAssessment.then(() => {
                    this.$store.commit('ScoringStore/clearTestTreeData');
                    this.$router.push('/scoring');
                });
                promiseEvaluateAssessment.catch(() => {
                    alert("Couldn't evaluate assessment. Please try again.");
                });
            },


            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***      BEGIN CODE         ***
             *******************************/

            // Handle Key/Mouse

            handleKeyDowns(event) {

                if (this.mustShowUrgentPopup === true || this.mustShowVitalParametersForm === true) {
                    return;
                }

                switch (event.keyCode) {

                    // Tab
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // Escape
                    case 27:
                        event.preventDefault();

                        // Escape
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            // Have Patient Comment in Icon + Popup
                            if (this.mustShowPatientPanel === false) {

                                // If patient comment is shown, close it
                                if (this.showComment === true) {
                                    this.savePatientComment();
                                }
                            }
                            else {
                                // Have Patient PID/Comment in page
                                if (this.shortcutNav.crtPanel === ASP_PANEL.PATIENT_INFO) {
                                    this.navDeactivatePatientInfoFields();
                                }
                            }
                        }
                        break;

                    // M
                    case 77:
                        // ALT + M
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                            event.preventDefault();
                            event.stopPropagation();
                            event.stopImmediatePropagation();

                            // If the keyboard combination has been pressed while scoring popup is shown, then close scoring popup
                            if (this.mustShowScoringPopup === true) {
                                this.$store.commit('AssessmentAlertsStore/setMustShowScoringPopup', false);
                            }

                            // If the keyboard combination has been pressed while GeneralQuestionAreNotAllAnswered popup is shown, then close the popup
                            if (this.mustGeneralQuestionAreNotAllAnsweredPopup === true) {
                                this.$store.commit('AssessmentStartStore/setGeneralQuestionAreNotAllAnsweredPopup', false);

                                this.shortcutNav.isFieldInEdit = true;
                                this.shortcutNav.isPanelHighlight = false;
                            }

                            // If the keyboard combination has been pressed while MedicalDeviceInfo popup is shown, then close the popup
                            if (this.mustShowInfoPopup === true) {
                                this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);

                                this.shortcutNav.isFieldInEdit = true;
                                this.shortcutNav.isPanelHighlight = false;
                            }

                            if (this.mustShowPatientPanel === false) {
                                // If Patient Info Panel is not shown
                                this.showComment = true;
                            }
                            else {
                                // Focus on textarea comment
                                this.navSetShortcutNavCrtPanel(ASP_PANEL.PATIENT_INFO, true);
                                this.shortcutNav.crtPatientField = PATIENT_INFO_FIELD.FIELD_COMMENT;
                                this.navSetIsKeyboardNav(true);
                                this.navActivatePatientInfoFields();
                            }
                        }
                        break;

                    // P
                    case 80:
                        // ALT + P
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {

                            if (this.medicalStatus === this.medicalStatuses.INFORMATION
                                || this.medicalStatus === this.medicalStatuses.URGENT) {

                                // for IE 11  - disable default behaviour
                                event.preventDefault();

                                if (this.mustGeneralQuestionAreNotAllAnsweredPopup === true) {
                                    this.$store.commit('AssessmentStartStore/setGeneralQuestionAreNotAllAnsweredPopup', false);
                                }

                                if (this.mustShowInfoPopup === true) {
                                    this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);
                                }

                                this.showScoringPopup();
                            }
                        }
                        break;
                    // V
                    case 86:
                        // ALT + V
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                            // Prevent the default behavior
                            event.preventDefault();


                            // If the scoring popup is shown, then close it
                            if (this.mustShowScoringPopup === true) {
                                this.$store.commit('AssessmentAlertsStore/setMustShowScoringPopup', false);
                            }

                            // If the info popup is shown, then close it
                            if (this.mustShowInfoPopup === true) {
                                this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);
                            }

                            // if the general question are not all answered popup is shown, then close it
                            if (this.mustGeneralQuestionAreNotAllAnsweredPopup === true) {
                                this.$store.commit('AssessmentStartStore/setGeneralQuestionAreNotAllAnsweredPopup', false);
                            }

                            // If we have a field in edit, then exit editing
                            if (this.navIsFieldInEdit() === true) {
                                this.navDeactivatePatientInfoFields();
                                this.shortcutNav.isFieldInEdit = false;
                            }

                            // Open the dropdown for the vital parameters
                            this.$store.commit('VitalParametersStore/setMustShowVitalParamsForm', true);

                            // Enable the keyboard navigation
                            this.shortcutNav.isKeyboardNav = true;
                        }

                        break;
                }

                if (this.mustShowScoringPopup === true || this.showComment === true || this.mustGeneralQuestionAreNotAllAnsweredPopup === true || this.mustShowInfoPopup === true) {
                    return;
                }

                // If we are editing the Patient comment or PID, do nothing in the main page
                if (this.shortcutNav.crtPanel === ASP_PANEL.PATIENT_INFO
                    && (this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_PID
                        || this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_COMMENT)
                    && this.navIsFieldInEdit() === true) {

                    return;
                }

                switch (event.keyCode) {

                    // Backspace
                    case 8:
                    // ALT
                    case 18:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // PageUp
                    case 33:
                        // PageUp
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {
                            event.preventDefault();
                            this.$refs["assessmentPriorityScrollingContentRef"].scrollTop -= 50;
                        }
                        break;

                    // PageDown
                    case 34:
                        // PageDown
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {
                            event.preventDefault();
                            this.$refs["assessmentPriorityScrollingContentRef"].scrollTop += 50;
                        }
                        break;

                    // ArrowLeft
                    case 37:
                    // ArrowUp
                    case 38:
                    // ArrowRight
                    case 39:
                    // ArrowDown
                    case 40:
                        event.preventDefault();
                        break;

                }

                //Prevent repeated calls for certain keys
                if (this.isKeyDown[event.keyCode] === true) {
                    return;
                }
                this.isKeyDown[event.keyCode] = true;

                switch (event.keyCode) {

                    // Enter
                    case 13:

                        if (this.shortcutNav.isKeyboardNav === false) {
                            return;
                        }

                        event.preventDefault();

                        // ENTER
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            switch (this.shortcutNav.crtPanel) {

                                case ASP_PANEL.QUESTIONS_PANEL:

                                    let questionPanelPage = this.$refs["questionsPriorityListRef"];
                                    if (questionPanelPage != null
                                        && questionPanelPage.handleChangeAnswerFromPriorityPage != null) {

                                        let questionIdx = this.questionListPriority.findIndex((currentQuestion) => {
                                            return currentQuestion.code === this.shortcutNav.crtQuestion;
                                        });

                                        if (questionIdx >= 0) {

                                            let question = this.questionListPriority[questionIdx];

                                            // is answered by Vital Parameter => open Vital Parameters Form
                                            if (question.answeredByVitalParam != null) {
                                                this.$store.commit('VitalParametersStore/setMustShowVitalParamsForm', true);
                                                this.$store.commit('VitalParametersStore/setFocusVitalParameter', question.answeredByVitalParam);

                                                // lose focus on current question => at Shift focus on the first Question
                                                this.shortcutNav.crtQuestion = null;
                                                this.shortcutNav.crtAnswer = null;
                                            }
                                            else {
                                                // is not answered by Vital Parameter => provide answer on Enter
                                                if (question.providedAnswer === this.shortcutNav.crtAnswer) {
                                                    questionPanelPage.handleChangeAnswerFromPriorityPage(this.shortcutNav.crtQuestion, this.shortcutNav.crtAnswer, false, question.answers);
                                                }
                                                else {
                                                    questionPanelPage.handleChangeAnswerFromPriorityPage(this.shortcutNav.crtQuestion, this.shortcutNav.crtAnswer, true, question.answers);
                                                }
                                            }
                                        }
                                    }
                                    break;

                                case ASP_PANEL.PATIENT_INFO:
                                    break;
                            }
                        }
                        break;

                    // Shift
                    case 16:
                        // SHIFT
                        event.preventDefault();
                        if (this.shortcutNav.crtPanel === ASP_PANEL.PATIENT_INFO
                            && (this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_PID || this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_COMMENT)
                            && this.navIsFieldInEdit() === true) {
                            // Do nothing. Do not enable PanelHighlight
                        }
                        else {
                            this.navEnablePanelHighlight();
                        }

                        break;

                    // PageDown
                    case 34:
                        // SHIFT + PageDown
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {
                            event.preventDefault();
                            this.goToNextPage();
                        }
                        break;

                    // End
                    case 35:
                        // SHIFT + End
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            event.preventDefault();

                            if (this.shortcutNav.crtPanel === ASP_PANEL.PATIENT_INFO &&
                                (this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_PID || this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_COMMENT) &&
                                this.navIsFieldInEdit() === true) {
                                // We're editing a patient field. Do nothing but the default behaviour
                            }
                            else {
                                this.gotoScoringPage();
                            }
                        }
                        break;

                    // ArrowLeft
                    case 37:

                        if (this.showComment === true) {
                            return;
                        }

                        this.navSetIsKeyboardNav(true);

                        // LEFT
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            switch (this.shortcutNav.crtPanel) {
                                case ASP_PANEL.QUESTIONS_PANEL:
                                    this.navAnswersRightLeft(false);
                                    break;
                            }
                        }
                        // CTRL + LEFT
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            switch (this.shortcutNav.crtPanel) {
                                case ASP_PANEL.QUESTIONS_PANEL:
                                    this.navAnswersLeftEdge();
                                    break;
                            }
                        }
                        // SHIFT + LEFT
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            // Small and Up (> 600px)
                            // Possible one column with PATIENT_INFO
                            // One columns with QUESTIONS_PANEL
                            if (this.$vuetify.breakpoint.smAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case ASP_PANEL.PATIENT_INFO:
                                        this.navQuestionsTop();
                                        break;

                                    case ASP_PANEL.QUESTIONS_PANEL:
                                        if (this.mustShowPatientPanel === true) {
                                            this.navSetShortcutNavCrtPanel(ASP_PANEL.PATIENT_INFO, true);
                                        }
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with possible PATIENT_INFO and QUESTIONS_PANEL
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case ASP_PANEL.PATIENT_INFO:
                                    case ASP_PANEL.QUESTIONS_PANEL:
                                        break;
                                }
                            }
                        }
                        // SHIFT + CTRL + LEFT
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {

                            // Small and Up (> 600px)
                            // One column with possible PATIENT_INFO
                            // One columns with QUESTIONS_PANEL
                            if (this.$vuetify.breakpoint.smAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case ASP_PANEL.PATIENT_INFO:
                                        break;

                                    case ASP_PANEL.QUESTIONS_PANEL:
                                        if (this.mustShowPatientPanel === true) {
                                            this.navSetShortcutNavCrtPanel(ASP_PANEL.PATIENT_INFO, true);
                                        }
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with possible PATIENT_INFO and QUESTIONS_PANEL
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case ASP_PANEL.PATIENT_INFO:
                                    case ASP_PANEL.QUESTIONS_PANEL:
                                        break;
                                }
                            }
                        }
                        break;

                    // ArrowUp
                    case 38:

                        if (this.showComment === true) {
                            return;
                        }

                        this.navSetIsKeyboardNav(true);

                        // UP
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            switch (this.shortcutNav.crtPanel) {
                                case ASP_PANEL.QUESTIONS_PANEL:
                                    this.navAnswersUp();
                                    break;

                                case ASP_PANEL.PATIENT_INFO:
                                    if (this.mustShowPatientPanel === true && this.navIsFieldInEdit() !== true) {
                                        this.navPatientFieldUpDown();
                                    }
                                    break;
                            }
                        }
                        // CTRL + UP
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            switch (this.shortcutNav.crtPanel) {
                                case ASP_PANEL.QUESTIONS_PANEL:
                                    this.navAnswersTop();
                                    break;

                                case ASP_PANEL.PATIENT_INFO:
                                    if (this.mustShowPatientPanel === true && this.navIsFieldInEdit() !== true) {
                                        this.navPatientFieldTopBottom(true);
                                    }
                                    break;
                            }
                        }
                        // SHIFT + UP
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            // Small and Up (> 600px)
                            // Possible one column with PATIENT_INFO
                            // One columns with QUESTIONS_PANEL
                            if (this.$vuetify.breakpoint.smAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case ASP_PANEL.PATIENT_INFO:
                                        break;

                                    case ASP_PANEL.QUESTIONS_PANEL:
                                        this.navQuestionsUp();
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with possible PATIENT_INFO and QUESTIONS_PANEL
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case ASP_PANEL.PATIENT_INFO:
                                        this.navQuestionsBottom();
                                        break;

                                    case ASP_PANEL.QUESTIONS_PANEL:

                                        let crtQuestionIdx = this.navGetCrtQuestionIdx();
                                        if (crtQuestionIdx < 0) {
                                            this.navSelectQuestion(0);
                                            return;
                                        }

                                        if (crtQuestionIdx === 0) {
                                            if (this.mustShowPatientPanel === true) {
                                                this.navSetShortcutNavCrtPanel(ASP_PANEL.PATIENT_INFO, true);
                                            }
                                            else {
                                                this.navQuestionsBottom();
                                            }
                                        }
                                        else {
                                            this.navSelectQuestion(crtQuestionIdx - 1);
                                        }
                                        break;
                                }
                            }
                        }
                        // SHIFT + CTRL + UP
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {

                            // Small and Up (> 600px)
                            // Possible one column with PATIENT_INFO
                            // One columns with QUESTIONS_PANEL
                            if (this.$vuetify.breakpoint.smAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case ASP_PANEL.PATIENT_INFO:
                                        break;

                                    case ASP_PANEL.QUESTIONS_PANEL:
                                        this.navQuestionsTop();
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with possible PATIENT_INFO and QUESTIONS_PANEL
                            else if (this.$vuetify.breakpoint.xsOnly) {
                                if (this.mustShowPatientPanel === true) {
                                    this.navSetShortcutNavCrtPanel(ASP_PANEL.PATIENT_INFO, true);
                                }
                                else {
                                    this.navQuestionsTop();
                                }
                            }
                        }
                        break;

                    // ArrowRight
                    case 39:

                        if (this.showComment === true) {
                            return;
                        }

                        this.navSetIsKeyboardNav(true);

                        // RIGHT
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            switch (this.shortcutNav.crtPanel) {
                                case ASP_PANEL.QUESTIONS_PANEL:
                                    this.navAnswersRightLeft(true);
                                    break;
                            }
                        }
                        // CTRL + RIGHT
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            switch (this.shortcutNav.crtPanel) {
                                case ASP_PANEL.QUESTIONS_PANEL:
                                    this.navAnswersRightEdge();
                                    break;
                            }
                        }
                        // SHIFT + RIGHT
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            // Small and Up (> 600px)
                            // Possible one column with PATIENT_INFO
                            // One columns with QUESTIONS_PANEL
                            if (this.$vuetify.breakpoint.smAndUp) {

                                switch (this.shortcutNav.crtPanel) {

                                    case ASP_PANEL.PATIENT_INFO:
                                        this.navQuestionsTop();
                                        break;

                                    case ASP_PANEL.QUESTIONS_PANEL:
                                        if (this.mustShowPatientPanel === true) {
                                            this.navSetShortcutNavCrtPanel(ASP_PANEL.PATIENT_INFO, true);
                                        }
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with possible PATIENT_INFO and QUESTIONS_PANEL
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case ASP_PANEL.PATIENT_INFO:
                                    case ASP_PANEL.QUESTIONS_PANEL:
                                        break;
                                }
                            }
                        }
                        // SHIFT + CTRL + RIGHT
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {

                            // Small and Up (> 600px)
                            // One column with possible PATIENT_INFO
                            // One columns with QUESTIONS_PANEL
                            if (this.$vuetify.breakpoint.smAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case ASP_PANEL.PATIENT_INFO:
                                        this.navQuestionsTop();
                                        break;

                                    case ASP_PANEL.QUESTIONS_PANEL:
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with possible PATIENT_INFO and QUESTIONS_PANEL
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case ASP_PANEL.PATIENT_INFO:
                                    case ASP_PANEL.QUESTIONS_PANEL:
                                        break;
                                }
                            }
                        }
                        break;

                    // ArrowDown
                    case 40:

                        if (this.showComment === true) {
                            return;
                        }

                        this.navSetIsKeyboardNav(true);

                        // DOWN
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            switch (this.shortcutNav.crtPanel) {
                                case ASP_PANEL.QUESTIONS_PANEL:
                                    this.navAnswersDown();
                                    break;

                                case ASP_PANEL.PATIENT_INFO:
                                    if (this.mustShowPatientPanel === true && this.navIsFieldInEdit() !== true) {
                                        this.navPatientFieldUpDown();
                                    }
                                    break;
                            }
                        }
                        // CTRL + DOWN
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            switch (this.shortcutNav.crtPanel) {
                                case ASP_PANEL.QUESTIONS_PANEL:
                                    this.navAnswersBottom();
                                    break;

                                case ASP_PANEL.PATIENT_INFO:
                                    if (this.mustShowPatientPanel === true && this.navIsFieldInEdit() !== true) {
                                        this.navPatientFieldTopBottom(false);
                                    }
                                    break;
                            }
                        }
                        // SHIFT + DOWN
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            // Small and Up (> 600px)
                            // Possible one column with PATIENT_INFO
                            // One columns with QUESTIONS_PANEL
                            if (this.$vuetify.breakpoint.smAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case ASP_PANEL.PATIENT_INFO:
                                        break;

                                    case ASP_PANEL.QUESTIONS_PANEL:
                                        this.navQuestionsDown();
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with possible PATIENT_INFO and QUESTIONS_PANEL
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case ASP_PANEL.PATIENT_INFO:
                                        this.navQuestionsTop();
                                        break;

                                    case ASP_PANEL.QUESTIONS_PANEL:

                                        let crtQuestionIdx = this.navGetCrtQuestionIdx();
                                        if (crtQuestionIdx < 0) {
                                            this.navSelectQuestion(0);
                                        }
                                        else {
                                            if (crtQuestionIdx === (this.questionListPriority.length - 1)) {
                                                if (this.mustShowPatientPanel === true) {
                                                    this.navSetShortcutNavCrtPanel(ASP_PANEL.PATIENT_INFO, true);
                                                }
                                                else {
                                                    this.navQuestionsTop();
                                                }
                                            }
                                            else {
                                                this.navSelectQuestion(crtQuestionIdx + 1);
                                            }
                                        }
                                        break;
                                }
                            }
                        }
                        // SHIFT + CTRL + DOWN
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {

                            // Small and Up (> 600px)
                            // Possible one column with PATIENT_INFO
                            // One columns with QUESTIONS_PANEL
                            if (this.$vuetify.breakpoint.smAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case ASP_PANEL.PATIENT_INFO:
                                        break;

                                    case ASP_PANEL.QUESTIONS_PANEL:
                                        this.navQuestionsBottom();
                                        break;

                                }
                            }
                            // Extra small (<600px)
                            // One column with possible PATIENT_INFO and QUESTIONS_PANEL
                            else if (this.$vuetify.breakpoint.xsOnly) {
                                this.navQuestionsBottom();
                            }
                        }
                        break;

                }
            },

            handleKeyUps(event) {

                this.isKeyDown[event.keyCode] = false;

                if (this.mustShowScoringPopup === true || this.mustShowUrgentPopup === true || this.mustShowInfoPopup === true || this.mustShowVitalParametersForm) {
                    return;
                }

                switch (event.keyCode) {

                    // Tab
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // Enter
                    case 13:
                        // ENTER
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            switch (this.shortcutNav.crtPanel) {

                                case ASP_PANEL.QUESTIONS_PANEL:
                                    break;

                                case ASP_PANEL.PATIENT_INFO:
                                    event.preventDefault();
                                    if (this.shortcutNav.isKeyboardNav === false) {
                                        return;
                                    }

                                    if (this.navIsFieldInEdit() === false) {
                                        this.navActivatePatientInfoFields();
                                    }
                                    break;
                            }
                        }
                        // CTRL + ENTER
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            if (this.mustShowPatientPanel === false) {
                                if (this.showComment === true) {
                                    // If Patient Info Panel is not shown, close Patient comment popup
                                    this.savePatientComment();
                                    this.navSetIsKeyboardNav(true);
                                }
                            }
                            else {

                                // Handled on keyUps because keyDowns doesn't handle CTRL + ENTER
                                if (this.shortcutNav.crtPanel === ASP_PANEL.PATIENT_INFO) {
                                    event.preventDefault();
                                    if (this.navIsFieldInEdit() === true) {

                                        this.navDeactivatePatientInfoFields();
                                        this.navSetIsKeyboardNav(true);
                                    }
                                }
                            }
                        }

                        break;

                    // Shift
                    case 16:
                        if (this.showComment === false) {
                            event.preventDefault();
                            this.navDisablePanelHighlight();
                            this.navFocusPanelElement();
                        }
                        break;

                    // ALT
                    case 18:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                }
            },

            handleClicks(event) {

                this.navSetIsKeyboardNav(false);
            },

            setIsKeyboardNav(value) {
                this.shortcutNav.isKeyboardNav = value;
            },

            // On Events

            onChangeAnswer(data) {

                this.navSelectQuestion(0);
            },

            onQuestionClick(data) {

                if (data === null || data.questionCode === null) {
                    return;
                }

                let isDifferentQuestion = (this.shortcutNav.crtQuestion !== data.questionCode);

                this.shortcutNav.crtQuestion = data.questionCode;

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    crtQuestionIdx = 0;
                }

                this.navSetShortcutNavCrtPanel(ASP_PANEL.QUESTIONS_PANEL, false);

                if (this.questionListPriority.length === 0) {
                    return;
                }

                let question = this.questionListPriority[crtQuestionIdx];

                // It can ce a different code if was executed "crtQuestionIdx = 0;"
                this.shortcutNav.crtQuestion = question.code;

                if (question.answers.length === 0) {
                    return;
                }

                if (isDifferentQuestion === true) {
                    this.shortcutNav.crtAnswer = question.answers[0].code;
                }
            },

            // Panel Highlight Enable/Disable

            navEnablePanelHighlight() {

                this.shortcutNav.isPanelHighlight = true;
                this.navSetIsKeyboardNav(true);

                this.navScrollIntoViewPanelOrQuestion();
            },

            navDisablePanelHighlight() {

                this.shortcutNav.isPanelHighlight = false;
            },

            navFocusPanelElement() {

                switch (this.shortcutNav.crtPanel) {

                    case ASP_PANEL.PATIENT_INFO:
                        this.navScrollIntoViewCrtPatientField();
                        break;

                    case ASP_PANEL.QUESTIONS_PANEL:

                        if (this.shortcutNav.crtQuestion === null) {
                            this.navSelectQuestion(0);
                        }
                        break;
                }

            },

            // Change current panel

            navSetShortcutNavCrtPanel(crtPanelNew, isScrollIntoView) {

                let crtPanelOld = this.shortcutNav.crtPanel;
                this.shortcutNav.crtPanel = crtPanelNew;

                if (isScrollIntoView === true) {
                    this.navScrollIntoViewPanelOrQuestion();
                }

                // Bellow code not used yet in this page. Possible actions when change current panel
                // We make actions only if the actual panel changed
                if (crtPanelOld !== crtPanelNew) {

                    switch (crtPanelOld) {
                        case ASP_PANEL.QUESTIONS_PANEL:
                            break;
                    }
                }
            },

            navSetIsKeyboardNav(isNavigation) {

                if (this.shortcutNav.isKeyboardNav === false && isNavigation === true) {
                    this.navFocusPanelElement();
                }

                this.shortcutNav.isKeyboardNav = isNavigation;
            },

            // Scroll Into View

            navScrollIntoViewPanelOrQuestion() {

                if (this.shortcutNav.crtPanel === ASP_PANEL.QUESTIONS_PANEL) {

                    let crtQuestionIdx = this.navGetCrtQuestionIdx();
                    if (crtQuestionIdx < 0) {
                        this.navSelectQuestion(0);
                    }
                    else {
                        this.navScrollIntoViewCrtQuestion();
                    }
                }
                else if (this.shortcutNav.crtPanel === ASP_PANEL.PATIENT_INFO) {
                    let panel = document.querySelector('.start-assessment-section');
                    let containerScrollable = document.querySelector('.scrolling-content');
                    containerScrollable.scrollTop = panel.offsetTop - 10;
                }
            },

            navScrollIntoViewCrtQuestion() {

                if (this.shortcutNav.crtQuestion === null) {
                    return;
                }

                if (this.$refs["questionsPriorityListRef"] != null
                    && this.$refs["questionsPriorityListRef"].$refs['vFlexQuestionRef_' + this.shortcutNav.crtQuestion] != null
                    && this.$refs["questionsPriorityListRef"].$refs['vFlexQuestionRef_' + this.shortcutNav.crtQuestion][0]) {

                    let containerScrollable = document.querySelector('.scrolling-content');
                    let questionPanel = this.$refs["questionsPriorityListRef"].$refs['vFlexQuestionRef_' + this.shortcutNav.crtQuestion][0];

                    containerScrollable.scrollTop = questionPanel.offsetTop - 35;
                }
            },

            // Questions Navigation

            navQuestionsDown() {

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }

                if (crtQuestionIdx === (this.questionListPriority.length - 1)) {
                    this.navSelectQuestion(0);
                }
                else {
                    this.navSelectQuestion(crtQuestionIdx + 1);
                }
            },

            navQuestionsUp() {

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }


                if (crtQuestionIdx === 0) {
                    this.navSelectQuestion(this.questionListPriority.length - 1);
                }
                else {
                    this.navSelectQuestion(crtQuestionIdx - 1);
                }
            },

            navQuestionsBottom() {
                this.navSelectQuestion(this.questionListPriority.length - 1);
            },

            navQuestionsTop() {
                this.navSelectQuestion(0);
            },

            navAnswersRightLeft(toRight) {

                if (this.shortcutNav.crtAnswer === null) {
                    this.navSelectQuestion(0);
                    return;
                }

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }

                let question = this.questionListPriority[crtQuestionIdx];

                let answerIdx = question.answers.findIndex((currentAnswer) => {
                    return currentAnswer.code === this.shortcutNav.crtAnswer;
                });

                if (answerIdx < 0) {
                    this.navSelectQuestion(crtQuestionIdx);
                    return;
                }

                if (toRight === true) {
                    // RIGHT
                    if (answerIdx === (question.answers.length - 1)) {

                        this.navSelectQuestionAnswer(crtQuestionIdx, 0);
                    }
                    else {
                        this.navSelectQuestionAnswer(crtQuestionIdx, answerIdx + 1);
                    }
                }
                else {
                    // LEFT
                    if (answerIdx === 0) {

                        this.navSelectQuestionAnswer(crtQuestionIdx, question.answers.length - 1);
                    }
                    else {
                        this.navSelectQuestionAnswer(crtQuestionIdx, answerIdx - 1);
                    }
                }
            },

            navAnswersRightEdge() {

                if (this.shortcutNav.crtAnswer === null) {
                    this.navSelectQuestion(0);
                    return;
                }

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }

                let question = this.questionListPriority[crtQuestionIdx];

                let answerIdx = question.answers.findIndex((currentAnswer) => {
                    return currentAnswer.code === this.shortcutNav.crtAnswer;
                });

                if (answerIdx < 0) {
                    this.navSelectQuestion(crtQuestionIdx);
                    return;
                }

                let answerTagList = {};

                question.answers.forEach((currentAnswer) => {
                    answerTagList[currentAnswer.code] = this.$refs["questionsPriorityListRef"].$refs['divAnswerRef_' + currentAnswer.code][0];
                });

                let crtAnswer = question.answers[answerIdx];

                let crtAnswerPanel = answerTagList[crtAnswer.code];

                let crtAnswerRect = crtAnswerPanel.getBoundingClientRect();

                let crtYMiddle = crtAnswerRect.top + ( crtAnswerRect.height / 2 );

                let farthestRightAnswer = null;
                let foundCurrentAnswer = false;

                question.answers.forEach((currentAnswer) => {

                    if (currentAnswer.code === crtAnswer.code) {
                        foundCurrentAnswer = true;
                        // Was found the current Answer. Do nothing for it.
                        return;
                    }

                    // Evaluate only answers after current Answer
                    if (foundCurrentAnswer === true) {

                        let currentAnswerTag = answerTagList[currentAnswer.code];
                        if (currentAnswerTag != null) {

                            let currentAnswerRect = currentAnswerTag.getBoundingClientRect();

                            let currentAnswerYMiddle = currentAnswerRect.top + ( currentAnswerRect.height / 2 );

                            //Search only for right buttons on the same line
                            if (crtYMiddle === currentAnswerYMiddle) {
                                farthestRightAnswer = currentAnswer;
                            }
                        }
                    }
                });

                if (farthestRightAnswer != null) {
                    this.navSelectQuestionAnswer(crtQuestionIdx, this.navGetAnswerIdx(question, farthestRightAnswer));
                }

            },

            navAnswersLeftEdge() {

                if (this.shortcutNav.crtAnswer === null) {
                    this.navSelectQuestion(0);
                    return;
                }

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }

                let question = this.questionListPriority[crtQuestionIdx];

                let answerIdx = question.answers.findIndex((currentAnswer) => {
                    return currentAnswer.code === this.shortcutNav.crtAnswer;
                });

                if (answerIdx < 0) {
                    this.navSelectQuestion(crtQuestionIdx);
                    return;
                }

                let answerTagList = {};

                question.answers.forEach((currentAnswer) => {
                    answerTagList[currentAnswer.code] = this.$refs["questionsPriorityListRef"].$refs['divAnswerRef_' + currentAnswer.code][0];
                });

                let crtAnswer = question.answers[answerIdx];

                let crtAnswerPanel = answerTagList[crtAnswer.code];

                let crtAnswerRect = crtAnswerPanel.getBoundingClientRect();

                let crtYMiddle = crtAnswerRect.top + ( crtAnswerRect.height / 2 );

                let farthestLeftAnswer = null;
                let foundCurrentAnswer = false;

                let answerListLength = question.answers.length;
                for (let i = answerListLength - 1; i >= 0; i--) {

                    let currentAnswer = question.answers[i];

                    if (currentAnswer.code === crtAnswer.code) {
                        foundCurrentAnswer = true;
                    }
                    // Evaluate only answers after current Answer
                    else if (foundCurrentAnswer === true) {

                        let currentAnswerTag = answerTagList[currentAnswer.code];
                        if (currentAnswerTag != null) {

                            let currentAnswerRect = currentAnswerTag.getBoundingClientRect();

                            let currentAnswerYMiddle = currentAnswerRect.top + ( currentAnswerRect.height / 2 );

                            //Search only for left buttons on the same line
                            if (crtYMiddle === currentAnswerYMiddle) {
                                farthestLeftAnswer = currentAnswer;
                            }
                        }
                    }
                }

                if (farthestLeftAnswer != null) {
                    this.navSelectQuestionAnswer(crtQuestionIdx, this.navGetAnswerIdx(question, farthestLeftAnswer));
                }

            },

            navAnswersDown() {

                if (this.shortcutNav.crtAnswer === null) {
                    this.navSelectQuestion(0);
                    return;
                }

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }

                let question = this.questionListPriority[crtQuestionIdx];

                let answerIdx = question.answers.findIndex((currentAnswer) => {
                    return currentAnswer.code === this.shortcutNav.crtAnswer;
                });

                if (answerIdx < 0) {
                    this.navSelectQuestion(crtQuestionIdx);
                    return;
                }

                let answerTagList = {};

                question.answers.forEach((currentAnswer) => {
                    answerTagList[currentAnswer.code] = this.$refs["questionsPriorityListRef"].$refs['divAnswerRef_' + currentAnswer.code][0];
                });

                let crtAnswer = question.answers[answerIdx];

                let crtAnswerPanel = answerTagList[crtAnswer.code];

                let crtAnswerRect = crtAnswerPanel.getBoundingClientRect();

                let crtXMiddle = crtAnswerRect.left + ( crtAnswerRect.width / 2 );
                let crtYMiddle = crtAnswerRect.top + ( crtAnswerRect.height / 2 );

                let nearestBellowAnswerDiff = null;
                let nearestBellowAnswer = null;
                let nextLineY = null;

                let foundCurrentAnswer = false;

                question.answers.forEach((currentAnswer) => {

                    if (currentAnswer.code === crtAnswer.code) {
                        foundCurrentAnswer = true;
                        // Was found the current Answer. Do nothing for it.
                        return;
                    }

                    // Evaluate only answers after current Answer
                    if (foundCurrentAnswer === true) {

                        let currentAnswerTag = answerTagList[currentAnswer.code];
                        if (currentAnswerTag != null) {

                            let currentAnswerRect = currentAnswerTag.getBoundingClientRect();

                            let currentAnswerXLeft = currentAnswerRect.left;
                            let currentAnswerXRight = currentAnswerRect.right;

                            let currentAnswerYMiddle = currentAnswerRect.top + ( currentAnswerRect.height / 2 );

                            //Search only for bellow buttons

                            if (crtYMiddle < currentAnswerYMiddle) {

                                if (nextLineY === null) {
                                    // Store the Y of the next line
                                    nextLineY = currentAnswerYMiddle;
                                }
                                else if (nextLineY < currentAnswerYMiddle) {
                                    // Consider only next line. Return if we start to check 2 lines bellow
                                    return;
                                }

                                let currentDistanceLeft = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXLeft, currentAnswerYMiddle);
                                let currentDistanceRight = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXRight, currentAnswerYMiddle);

                                // Choose the near one
                                let currentDistance;
                                if (currentDistanceLeft < currentDistanceRight) {
                                    currentDistance = currentDistanceLeft;
                                }
                                else {
                                    currentDistance = currentDistanceRight;
                                }

                                if (nearestBellowAnswerDiff === null) {
                                    nearestBellowAnswerDiff = currentDistance;
                                    nearestBellowAnswer = currentAnswer;
                                }
                                else if (currentDistance < nearestBellowAnswerDiff) {
                                    nearestBellowAnswerDiff = currentDistance
                                    nearestBellowAnswer = currentAnswer;
                                }
                            }
                        }
                    }
                });

                if (nearestBellowAnswer != null) {
                    this.navSelectQuestionAnswer(crtQuestionIdx, this.navGetAnswerIdx(question, nearestBellowAnswer));
                }
                else {
                    // Was not found bellow. Navigate to the first line, vertically

                    let nearestAnswerDiff = null;
                    let nearestAnswer = null;

                    let firstLineY = null;

                    question.answers.forEach((currentAnswer) => {

                        if (currentAnswer.code !== crtAnswer.code) {

                            let currentAnswerTag = answerTagList[currentAnswer.code];
                            if (currentAnswerTag != null) {

                                let currentAnswerRect = currentAnswerTag.getBoundingClientRect();

                                let currentAnswerXLeft = currentAnswerRect.left;
                                let currentAnswerXRight = currentAnswerRect.right;

                                let currentAnswerYMiddle = currentAnswerRect.top + ( currentAnswerRect.height / 2 );

                                //Search only for bellow buttons

                                if (crtYMiddle > currentAnswerYMiddle) {

                                    if (firstLineY === null) {
                                        // Store the Y of the first line
                                        firstLineY = currentAnswerYMiddle;
                                    }
                                    else if (firstLineY < currentAnswerYMiddle) {
                                        // Consider only first line. Return if we start to check lines bellow
                                        return;
                                    }

                                    let currentDistanceLeft = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXLeft, currentAnswerYMiddle);
                                    let currentDistanceRight = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXRight, currentAnswerYMiddle);

                                    // Choose the near one
                                    let currentDistance;
                                    if (currentDistanceLeft < currentDistanceRight) {
                                        currentDistance = currentDistanceLeft;
                                    }
                                    else {
                                        currentDistance = currentDistanceRight;
                                    }

                                    if (nearestAnswerDiff === null) {
                                        nearestAnswerDiff = currentDistance;
                                        nearestAnswer = currentAnswer;
                                    }
                                    else if (currentDistance < nearestAnswerDiff) {
                                        nearestAnswerDiff = currentDistance
                                        nearestAnswer = currentAnswer;
                                    }
                                }
                            }
                        }
                    });

                    if (nearestAnswer != null) {
                        this.navSelectQuestionAnswer(crtQuestionIdx, this.navGetAnswerIdx(question, nearestAnswer));
                    }
                    else {
                        // Do nothing
                    }
                }

            },

            navAnswersUp() {

                if (this.shortcutNav.crtAnswer === null) {
                    this.navSelectQuestion(0);
                    return;
                }

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }

                let question = this.questionListPriority[crtQuestionIdx];

                if (question.answeredByVitalParam !== null) {
                    return;
                }

                let answerIdx = question.answers.findIndex((currentAnswer) => {
                    return currentAnswer.code === this.shortcutNav.crtAnswer;
                });

                if (answerIdx < 0) {
                    this.navSelectQuestion(crtQuestionIdx);
                    return;
                }

                let answerTagList = {};

                question.answers.forEach((currentAnswer) => {
                    answerTagList[currentAnswer.code] = this.$refs["questionsPriorityListRef"].$refs['divAnswerRef_' + currentAnswer.code][0];
                });

                let crtAnswer = question.answers[answerIdx];

                let crtAnswerPanel = answerTagList[crtAnswer.code];

                let crtAnswerRect = crtAnswerPanel.getBoundingClientRect();

                let crtXMiddle = crtAnswerRect.left + ( crtAnswerRect.width / 2 );
                let crtYMiddle = crtAnswerRect.top + ( crtAnswerRect.height / 2 );

                let nearestAnswerDiff = null;
                let nearestAnswer = null;
                let previousLineY = null;

                let answerListLength = question.answers.length;
                for (let i = answerListLength - 1; i >= 0; i--) {

                    let currentAnswer = question.answers[i];

                    // Evaluate only answers after current Answer
                    if (currentAnswer.code !== crtAnswer.code) {

                        let currentAnswerTag = answerTagList[currentAnswer.code];
                        if (currentAnswerTag != null) {

                            let currentAnswerRect = currentAnswerTag.getBoundingClientRect();

                            let currentAnswerXLeft = currentAnswerRect.left;
                            let currentAnswerXRight = currentAnswerRect.right;

                            let currentAnswerYMiddle = currentAnswerRect.top + ( currentAnswerRect.height / 2 );

                            //Search only for bellow buttons

                            if (crtYMiddle > currentAnswerYMiddle) {

                                if (previousLineY === null) {
                                    // Store the Y of the previous line
                                    previousLineY = currentAnswerYMiddle;
                                }
                                else if (previousLineY > currentAnswerYMiddle) {
                                    // Consider only previous line. Return if we start to check 2 lines above
                                    continue;
                                }

                                let currentDistanceLeft = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXLeft, currentAnswerYMiddle);
                                let currentDistanceRight = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXRight, currentAnswerYMiddle);

                                // Choose the near one
                                let currentDistance;
                                if (currentDistanceLeft < currentDistanceRight) {
                                    currentDistance = currentDistanceLeft;
                                }
                                else {
                                    currentDistance = currentDistanceRight;
                                }

                                if (nearestAnswerDiff === null) {
                                    nearestAnswerDiff = currentDistance;
                                    nearestAnswer = currentAnswer;
                                }
                                else if (currentDistance < nearestAnswerDiff) {
                                    nearestAnswerDiff = currentDistance
                                    nearestAnswer = currentAnswer;
                                }
                            }
                        }
                    }
                }

                if (nearestAnswer != null) {
                    this.navSelectQuestionAnswer(crtQuestionIdx, this.navGetAnswerIdx(question, nearestAnswer));
                }
                else {
                    // Was not found above. Navigate to the last line, vertically

                    let nearestAnswerDiff = null;
                    let nearestAnswer = null;

                    let lastLineY = null;

                    let answerListLength = question.answers.length;
                    for (let i = answerListLength - 1; i >= 0; i--) {

                        let currentAnswer = question.answers[i];

                        if (currentAnswer.code !== crtAnswer.code) {

                            let currentAnswerTag = answerTagList[currentAnswer.code];
                            if (currentAnswerTag != null) {

                                let currentAnswerRect = currentAnswerTag.getBoundingClientRect();

                                let currentAnswerXLeft = currentAnswerRect.left;
                                let currentAnswerXRight = currentAnswerRect.right;

                                let currentAnswerYMiddle = currentAnswerRect.top + ( currentAnswerRect.height / 2 );

                                if (crtYMiddle < currentAnswerYMiddle) {

                                    if (lastLineY === null) {
                                        // Store the Y of the last line
                                        lastLineY = currentAnswerYMiddle;
                                    }
                                    else if (lastLineY > currentAnswerYMiddle) {
                                        // Consider only last line
                                        continue;
                                    }

                                    let currentDistanceLeft = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXLeft, currentAnswerYMiddle);
                                    let currentDistanceRight = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXRight, currentAnswerYMiddle);

                                    // Choose the near one
                                    let currentDistance;
                                    if (currentDistanceLeft < currentDistanceRight) {
                                        currentDistance = currentDistanceLeft;
                                    }
                                    else {
                                        currentDistance = currentDistanceRight;
                                    }

                                    if (nearestAnswerDiff === null) {
                                        nearestAnswerDiff = currentDistance;
                                        nearestAnswer = currentAnswer;
                                    }
                                    else if (currentDistance < nearestAnswerDiff) {
                                        nearestAnswerDiff = currentDistance
                                        nearestAnswer = currentAnswer;
                                    }
                                }
                            }
                        }
                    }

                    if (nearestAnswer != null) {
                        this.navSelectQuestionAnswer(crtQuestionIdx, this.navGetAnswerIdx(question, nearestAnswer));
                    }
                    else {
                        // Do nothing
                    }
                }

            },

            navAnswersTop() {

                if (this.shortcutNav.crtAnswer === null) {
                    this.navSelectQuestion(0);
                    return;
                }

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }

                let question = this.questionListPriority[crtQuestionIdx];

                let answerIdx = question.answers.findIndex((currentAnswer) => {
                    return currentAnswer.code === this.shortcutNav.crtAnswer;
                });

                if (answerIdx < 0) {
                    this.navSelectQuestion(crtQuestionIdx);
                    return;
                }

                let answerTagList = {};

                question.answers.forEach((currentAnswer) => {
                    answerTagList[currentAnswer.code] = this.$refs["questionsPriorityListRef"].$refs['divAnswerRef_' + currentAnswer.code][0];
                });

                let crtAnswer = question.answers[answerIdx];

                let crtAnswerPanel = answerTagList[crtAnswer.code];

                let crtAnswerRect = crtAnswerPanel.getBoundingClientRect();

                let crtXMiddle = crtAnswerRect.left + ( crtAnswerRect.width / 2 );
                let crtYMiddle = crtAnswerRect.top + ( crtAnswerRect.height / 2 );

                // Navigate to the first line, vertically

                let nearestAnswerDiff = null;
                let nearestAnswer = null;

                let firstLineY = null;

                question.answers.forEach((currentAnswer) => {

                    if (currentAnswer.code !== crtAnswer.code) {

                        let currentAnswerTag = answerTagList[currentAnswer.code];
                        if (currentAnswerTag != null) {

                            let currentAnswerRect = currentAnswerTag.getBoundingClientRect();

                            let currentAnswerXLeft = currentAnswerRect.left;
                            let currentAnswerXRight = currentAnswerRect.right;

                            let currentAnswerYMiddle = currentAnswerRect.top + ( currentAnswerRect.height / 2 );

                            //Search only for bellow buttons

                            if (crtYMiddle > currentAnswerYMiddle) {

                                if (firstLineY === null) {
                                    // Store the Y of the first line
                                    firstLineY = currentAnswerYMiddle;
                                }
                                else if (firstLineY < currentAnswerYMiddle) {
                                    // Consider only first line. Return if we start to check lines bellow
                                    return;
                                }

                                let currentDistanceLeft = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXLeft, currentAnswerYMiddle);
                                let currentDistanceRight = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXRight, currentAnswerYMiddle);

                                // Choose the near one
                                let currentDistance;
                                if (currentDistanceLeft < currentDistanceRight) {
                                    currentDistance = currentDistanceLeft;
                                }
                                else {
                                    currentDistance = currentDistanceRight;
                                }

                                if (nearestAnswerDiff === null) {
                                    nearestAnswerDiff = currentDistance;
                                    nearestAnswer = currentAnswer;
                                }
                                else if (currentDistance < nearestAnswerDiff) {
                                    nearestAnswerDiff = currentDistance
                                    nearestAnswer = currentAnswer;
                                }
                            }
                        }
                    }
                });

                if (nearestAnswer != null) {
                    this.navSelectQuestionAnswer(crtQuestionIdx, this.navGetAnswerIdx(question, nearestAnswer));
                }
                else {
                    // Do nothing
                }

            },

            navAnswersBottom() {

                if (this.shortcutNav.crtAnswer === null) {
                    this.navSelectQuestion(0);
                    return;
                }

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }

                let question = this.questionListPriority[crtQuestionIdx];

                let answerIdx = question.answers.findIndex((currentAnswer) => {
                    return currentAnswer.code === this.shortcutNav.crtAnswer;
                });

                if (answerIdx < 0) {
                    this.navSelectQuestion(crtQuestionIdx);
                    return;
                }

                let answerTagList = {};

                question.answers.forEach((currentAnswer) => {
                    answerTagList[currentAnswer.code] = this.$refs["questionsPriorityListRef"].$refs['divAnswerRef_' + currentAnswer.code][0];
                });

                let crtAnswer = question.answers[answerIdx];

                let crtAnswerPanel = answerTagList[crtAnswer.code];

                let crtAnswerRect = crtAnswerPanel.getBoundingClientRect();

                let crtXMiddle = crtAnswerRect.left + ( crtAnswerRect.width / 2 );
                let crtYMiddle = crtAnswerRect.top + ( crtAnswerRect.height / 2 );

                // Navigate to the last line, vertically

                let nearestAnswerDiff = null;
                let nearestAnswer = null;

                let lastLineY = null;

                let answerListLength = question.answers.length;
                for (let i = answerListLength - 1; i >= 0; i--) {

                    let currentAnswer = question.answers[i];

                    if (currentAnswer.code !== crtAnswer.code) {

                        let currentAnswerTag = answerTagList[currentAnswer.code];
                        if (currentAnswerTag != null) {

                            let currentAnswerRect = currentAnswerTag.getBoundingClientRect();

                            let currentAnswerXLeft = currentAnswerRect.left;
                            let currentAnswerXRight = currentAnswerRect.right;

                            let currentAnswerYMiddle = currentAnswerRect.top + ( currentAnswerRect.height / 2 );

                            if (crtYMiddle < currentAnswerYMiddle) {

                                if (lastLineY === null) {
                                    // Store the Y of the last line
                                    lastLineY = currentAnswerYMiddle;
                                }
                                else if (lastLineY > currentAnswerYMiddle) {
                                    // Consider only last line
                                    continue;
                                }

                                let currentDistanceLeft = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXLeft, currentAnswerYMiddle);
                                let currentDistanceRight = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXRight, currentAnswerYMiddle);

                                // Choose the near one
                                let currentDistance;
                                if (currentDistanceLeft < currentDistanceRight) {
                                    currentDistance = currentDistanceLeft;
                                }
                                else {
                                    currentDistance = currentDistanceRight;
                                }

                                if (nearestAnswerDiff === null) {
                                    nearestAnswerDiff = currentDistance;
                                    nearestAnswer = currentAnswer;
                                }
                                else if (currentDistance < nearestAnswerDiff) {
                                    nearestAnswerDiff = currentDistance
                                    nearestAnswer = currentAnswer;
                                }
                            }
                        }
                    }
                }

                if (nearestAnswer != null) {
                    this.navSelectQuestionAnswer(crtQuestionIdx, this.navGetAnswerIdx(question, nearestAnswer));
                }
                else {
                    // Do nothing
                }

            },

            // QUESTIONS Panels

            navSelectQuestion(selectQuestionIdx) {

                this.navSelectQuestionAnswer(selectQuestionIdx, 0);
            },

            navSelectQuestionAnswer(selectQuestionIdx, selectAnswerIdx) {

                this.navSetShortcutNavCrtPanel(ASP_PANEL.QUESTIONS_PANEL, false);

                if (this.questionListPriority.length === 0) {
                    return;
                }

                let question = this.questionListPriority[selectQuestionIdx];
                this.shortcutNav.crtQuestion = question.code;

                this.navScrollIntoViewCrtQuestion();

                if (question.answers.length === 0) {
                    return;
                }

                this.shortcutNav.crtAnswer = question.answers[selectAnswerIdx].code;
            },

            navGetCrtQuestionIdx() {

                let crtQuestionIdx = -1;
                if (this.shortcutNav.crtQuestion != null) {
                    crtQuestionIdx = this.questionListPriority.findIndex((currentQuestion, currentIndex) => {
                        if (currentQuestion.code === this.shortcutNav.crtQuestion) {
                            return true;
                        }
                    });
                }
                return crtQuestionIdx;
            },

            navGetAnswerIdx(questionParam, answerParam) {

                let answerIdx = -1;
                answerIdx = questionParam.answers.findIndex((currentAnswer) => {
                    if (currentAnswer.code === answerParam.code) {
                        return true;
                    }
                });
                return answerIdx;
            },

            getDistance(crtAnswerXMiddle, crtAnswerYMiddle, relatedAnswerX, relatedAnswerYMiddle) {

                let xDiff = Math.abs(relatedAnswerX - crtAnswerXMiddle);
                let yDiff = Math.abs(crtAnswerYMiddle - relatedAnswerYMiddle);

                return Math.sqrt((xDiff * xDiff) + (yDiff * yDiff));
            },

            onPanelClick(crtPanelNew) {

                this.shortcutNav.crtPanel = crtPanelNew;
            },

            // Patient Info handling

            navPatientFieldUpDown() {

                switch (this.shortcutNav.crtPatientField) {

                    case PATIENT_INFO_FIELD.FIELD_PID:
                        this.shortcutNav.crtPatientField = PATIENT_INFO_FIELD.FIELD_COMMENT;
                        this.navScrollIntoViewCrtPatientField();
                        break;

                    case PATIENT_INFO_FIELD.FIELD_COMMENT:
                        this.shortcutNav.crtPatientField = PATIENT_INFO_FIELD.FIELD_PID;
                        this.navScrollIntoViewCrtPatientField();
                        break;
                }
            },

            navPatientFieldTopBottom(isUp) {

                switch (this.shortcutNav.crtPatientField) {

                    case PATIENT_INFO_FIELD.FIELD_PID:
                        if (isUp === false) {
                            this.shortcutNav.crtPatientField = PATIENT_INFO_FIELD.FIELD_COMMENT;
                            this.navScrollIntoViewCrtPatientField();
                        }
                        break;

                    case PATIENT_INFO_FIELD.FIELD_COMMENT:
                        if (isUp === true) {
                            this.shortcutNav.crtPatientField = PATIENT_INFO_FIELD.FIELD_PID;
                            this.navScrollIntoViewCrtPatientField();
                        }
                        break;
                }
            },

            navScrollIntoViewCrtPatientField() {

                // Return when Patient Panel is not shown
                if (this.mustShowPatientPanel === false) {
                    return;
                }

                let containerScrollable = document.querySelector('.scrolling-content');

                if (this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_PID) {
                    containerScrollable.scrollTop = this.$refs['patientProfileRef'].$refs['vTextFieldPidRef'].$el.offsetTop - 120;
                }
                else if (this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_COMMENT) {
                    containerScrollable.scrollTop = this.$refs['patientProfileRef'].$refs['vTextFieldPatientCommentRef'].$el.offsetTop - 120;
                }
            },

            navDeactivatePatientInfoFields() {

                switch (this.shortcutNav.crtPatientField) {

                    case PATIENT_INFO_FIELD.FIELD_PID:
                        this.$refs['patientProfileRef'].$refs['vTextFieldPidRef'].$refs.input.blur();
                        break;
                    case PATIENT_INFO_FIELD.FIELD_COMMENT:
                        this.$refs['patientProfileRef'].$refs['vTextFieldPatientCommentRef'].$refs.input.blur();
                        break;
                }
            },

            navActivatePatientInfoFields() {

                switch (this.shortcutNav.crtPatientField) {

                    case PATIENT_INFO_FIELD.FIELD_PID:
                        this.$refs['patientProfileRef'].$refs['vTextFieldPidRef'].$refs.input.focus();
                        break;
                    case PATIENT_INFO_FIELD.FIELD_COMMENT:
                        this.$refs['patientProfileRef'].$refs['vTextFieldPatientCommentRef'].$refs.input.focus();
                        break;
                }
            },

            navIsFieldInEdit() {

                if (this.$refs['patientProfileRef'] != null
                    && this.$refs['patientProfileRef'].$refs['vTextFieldPidRef'] != null
                    && this.$refs['patientProfileRef'].$refs['vTextFieldPatientCommentRef'] != null
                    && document.activeElement != null) {

                    let isFieldInEdit = this.$refs['patientProfileRef'].$refs['vTextFieldPidRef'].$refs.input === document.activeElement
                        || this.$refs['patientProfileRef'].$refs['vTextFieldPatientCommentRef'].$refs.input === document.activeElement;

                    return isFieldInEdit;

                }
                return false;
            }


            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***        END CODE         ***
             *******************************/

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
    .container.grid-list-xl {

        .layout.general-info {
            margin-bottom: -95px;
        }

    }

    .topbar-patient-info-content {
        position: fixed;
        left: 45px !important;
        margin-top: 12px;
        // SMASSDEV - 1119
        font-size: $font-size-extra-small;
        // word-spacing: $word-spacing-extra-small;
        // line-height: $line-height-extra-small;
        // letter-spacing: $letter-spacing-extra-small;
    }

    .priority-questions-auto-login {
        margin-left: 12px !important;
        padding-left: 0 !important;

    }

    @media only screen and (min-width: 600px) {
        .symptom-description {
            // 83px - page header
            // 61px - top bar
            // 60px - bottom bar
            // 34px - blank space above the Symptom Description box.
            // 16px - blank space below the Symptom Description box.
            height: calc(100vh - 83px - 61px - 60px - 34px - 16px);
            overflow: auto;
        }
    }

    .selected-symptoms.hide-patient-panel {
        padding-left: 0 !important;
    }

    .symptom-description-hide-patient-panel {
        padding-top: 0 !important;
    }

    .assessment-start-priority-list-questions {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

    @media only screen and (min-width: 600px) {
        .container.assessment-start-container {
            .sticky-column {
                position: fixed;
                //right: 20px !important;
                width: 16% !important;

                &.symptom-description-hide-patient-panel  {
                    width: 24% !important;
                }

            }
        }
    }

    .container.assessment-start-container {
        .selected-symptoms {
            margin-top: 12px !important;
            padding-right: 6px !important;
        }
    }

    @media only screen and (min-width: 1025px) {
        .container.assessment-start-container {
            .sticky-column {
                right: 1.75rem !important;
            }
        }
    }

    @media only screen and (max-width: 1024px) {
        .container.assessment-start-container {
            .sticky-column {
                right: 1.375rem !important;
            }
        }
    }

    @media only screen and (max-height: 850px) and (max-width: 1024px) {
        .container.assessment-start-container {
            .sticky-column {
                right: 1.75rem !important;
            }
        }
    }

    @media only screen and (max-width: 1265px) {
        .assessment-start-container .scrolling-content .layout .flex.sticky-column {
            padding-right: 0 !important;
        }
    }

</style>




// WEBPACK FOOTER //
// src/professional/components/assessment-start/AssessmentStartListPage.vue